import { useParams } from 'react-router';

export const useIsValwin = () => {
  const { group } = useParams();

  return 'valwin' === group;
};
